// 펫 집(하우스) 카탈로그 — 펫이 머무는 공간. (이미지 에셋 준비 전 이모지 플레이스홀더)
// price: 🥕 가격. 실제 적용/구매는 추후 서버 연동. 이미지 생기면 emoji 대신 src 필드로 교체.
export default [
  { emoji: "🏠", name: "기본 집", price: 1500 },
  { emoji: "🏡", name: "정원 딸린 집", price: 3000 },
  { emoji: "🛖", name: "오두막", price: 1200 },
  { emoji: "⛺", name: "텐트", price: 800 },
  { emoji: "🏚️", name: "빈티지 하우스", price: 2000 },
  { emoji: "🏯", name: "일본식 성", price: 10000 },
  { emoji: "🏰", name: "동화 속 성", price: 12000 },
  { emoji: "🗼", name: "타워 하우스", price: 8000 },
];
